module.exports = __webpack_public_path__ + "static/media/note-1_5.893235c5.png";